import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SkeletonProps } from '../../interfaces/SkeletonProps';

import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import Refresh from '../Refresh/Refresh';

export const InMemoryFundraisersListSkeleton: FunctionComponent<SkeletonProps> = ({
  animated,
  displayRefreshButton,
  onRefresh,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <Refresh
      className={classNames('jg-display-flex jg-flex-column jg-flex-aic')}
      displayRefreshButton={displayRefreshButton}
      onRefresh={onRefresh}
      buttonLabel={t('inMemory.fundraisers.refresh')}
    >
      <PlaceholderBar width="75%" height={36} animated={animated} />
      <PlaceholderBar width="50%" height={18} animated={animated} />
      <PlaceholderBar
        width="60%"
        height={18}
        animated={animated}
        className="jg-space-mbn"
      />
    </Refresh>
  );
};
